/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateUserRoleDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type UpdateUserRoleDataRoleSchema = z.infer<typeof updateUserRoleDataRoleSchema>
